module.exports = __webpack_public_path__ + "img/mongodb.c1e09d9.svg";